<template>
  <a class="content-card" :aria-label="title" :href="ctaUrl">
    <responsive-image
      class="content-card__image"
      :image="teaserImage.image"
      ratio="2:1"
      sizes="(min-width: 1024px) 620px, 375px"
    />

    <div v-if="badge" class="content-card__badge" v-text="badge" />

    <div class="content-card__content">
      <p
        v-if="title"
        class="content-card__title text-mobile-headlines-h4 text-desktop-headlines-h4"
        v-text="title"
      />
      <div class="content-card__description">
        <p
          v-if="description"
          class="content-card__description--text text-mobile-paragraph-s-regular text-desktop-paragraph-s-regular"
          v-text="description"
        />
      </div>
      <div class="content-card__features">
        <icon-text
          v-for="(feature, index) of displayFeatures"
          :key="index"
          class="mr-m"
          :text="feature.description"
          :icon="feature.icon"
        />
      </div>

      <btn
        class="content-card__cta text-mobile-paragraph-m-regular-link text-desktop-paragraph-m-regular-link"
        :label="ctaLabel"
        :aria-label="title"
        modifiers="secondary center"
        size="large-large"
      />
    </div>
  </a>
</template>

<script>
/**
 * Vue: content-card (content-card)
 * -----------------------------------------------------------------------------
 * Product card used throughout the site.
 *
 * @param {Boolean} [lazyload] - Lazy load image.
 * @param {String} title - Render title.
 * @param {String} description - Render description.
 * @param {String} badge - Badge in the upper left of image, optional.
 * @param {String} [teaserImage] - Render image.
 * @param {String} ctaLabel - Label for the cta button.
 * @param {String} ctaUrl - Url for the cta button.
 * @param {String} [displayFeatures] - Level.
 *
 */
import Btn from '~global/btn/btn';
import ResponsiveImage from '~global/images/responsive-image.vue';
import IconText from '~async/icon-text/icon-text.vue';

export default {
  name: 'ContentCard',

  components: {
    Btn,
    ResponsiveImage,
    IconText,
  },

  props: {
    teaserImage: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: 'Test',
    },
    description: {
      type: String,
      default: 'Test',
    },
    badge: {
      type: String,
      default: null,
    },
    ctaLabel: {
      type: String,
      default: 'Test',
    },
    ctaUrl: {
      type: String,
      default: 'Test',
    },
    displayFeatures: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      cnvsGlobal: true,
    };
  },
};
</script>

<style lang="scss">
@import './content-card';
</style>
